<!--
 * @Author: yaoyuting
 * @Date: 2019-08-28 21:44:30
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-03-23 17:36:18
 * @Descripttion:
-->
<template>
  <div class="home">
    <div class="Header">
      <Header></Header>
    </div>
    <div class="Main">
      <Main></Main>
    </div>
    <div class="Footer">
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import Header from "@/components/pc/Header";
import Main from "@/components/pc/Main";
import Footer from "@/components/pc/Footer";
export default {
  components: {
    Header: Header,
    Main: Main,
    Footer: Footer,
  },
  name: "HelloWorld",
  props: {
    msg: String,
  },
};
</script>

<style scoped lang="less">
.el-menu--horizontal .el-menu {
  background-color: #fff !important;
  box-shadow: 0px 31px 136px 1px rgba(0, 0, 0, 0.15) !important;
}
body {
  text-align: center;
}

.home {
  min-width: 1200px;
  margin: 0 auto;
  /*background-color: rgba(0, 0, 0, 0);*/
  background: linear-gradient(180deg, #f2f5f9 0%, #f3f5f9 30%, #ffffff 41%);
  border-radius: 0px 0px 0px 0px;
}
.Header {
  width: 100%;
  background-color: rgba(0, 0, 0, 0);
  // height: 100px;
}
.Main {
  width: 100%;
  // margin-top: 96px;
  background-color: rgba(0, 0, 0, 0);
}
.Footer {
  width: 100%;
  display: flex;
  justify-content: center;
  background: #f5eefd;
}
</style>
